var autoEnableSubmitButtons = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @param {int} delay
	 *
	 * @returns {void}
	 */
	init: function(target, delay = 300) {

		window.app.domStateReady(function() {
			setTimeout(function() {
				autoEnableSubmitButtons.enable(target);
			}, delay);
		});

	},

	enable: function(target) {
		var elements = target.querySelectorAll('[type=submit][data-auto-enable=true]');
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].hasAttribute('disabled')) {
				elements[i].removeAttribute('disabled');
			}
		}
	}

};

export default autoEnableSubmitButtons;
